import { Link } from "react-router-dom";
import {
  ArrowRight,
  Waves,
  Sun,
  UtensilsCrossed,
  Dog,
  Map as MapIcon,
  Mountain,
  Calendar,
  Cloud,
  Moon,
  Landmark,
  Fish,
  Clock,
} from "lucide-react";

const teasers: { to: string; label: string; description: string; icon: typeof Waves }[] = [
  { to: "/right-now", label: "Best Beach Right Now", description: "Live ranking of San Diego beaches by water quality and time of day.", icon: Clock },
  { to: "/beaches", label: "Beaches", description: "From La Jolla Cove to Coronado — sand, surf, and tide pools.", icon: Waves },
  { to: "/guides/best-beaches-in-san-diego", label: "Best Beaches", description: "Our ranked local picks for every vibe — snorkeling, surf, families, sunset.", icon: Sun },
  { to: "/guides/dog-friendly-beaches-san-diego", label: "Dog Beaches", description: "Every off-leash and leashed-friendly beach for dogs in San Diego.", icon: Dog },
  { to: "/guides/la-jolla-cove-snorkeling", label: "Snorkeling", description: "When to snorkel La Jolla Cove, what you'll see, and where to rent gear.", icon: Fish },
  { to: "/surf", label: "Surf Reports", description: "Live wave heights, swell direction, and beginner-friendly breaks.", icon: Waves },
  { to: "/tides", label: "Tides", description: "Daily tide tables and how to read them for safe shore time.", icon: Cloud },
  { to: "/weather", label: "Weather", description: "Current conditions, marine forecasts, and seasonal climate.", icon: Sun },
  { to: "/dining", label: "Dining", description: "Oceanfront restaurants, casual taquerias, and rooftop bars.", icon: UtensilsCrossed },
  { to: "/culture", label: "Culture", description: "Museums, galleries, and craft breweries along the coast.", icon: Landmark },
  { to: "/trails", label: "Trails", description: "Coastal hikes from Torrey Pines to Cabrillo and back.", icon: Mountain },
  { to: "/guides/whale-watching-san-diego", label: "Whale Watching", description: "Seasonal guide to gray whales in winter and blue whales in summer.", icon: Fish },
  { to: "/map", label: "Coastal Map", description: "Every spot on the guide, plotted along the San Diego coast.", icon: MapIcon },
  { to: "/events", label: "Events", description: "Festivals, farmers markets, and seasonal happenings.", icon: Calendar },
  { to: "/moon", label: "Moon Tracker", description: "Phases, moonrise, and tide influence — at a glance.", icon: Moon },
];


const TeaserGrid = () => (
  <section className="bg-background px-6 py-24 border-t border-border">
    <div className="mx-auto max-w-6xl">
      <p className="font-body text-xs font-medium uppercase tracking-[0.3em] text-muted-foreground">
        The Guide
      </p>
      <h2 className="font-display mt-3 text-4xl font-semibold text-foreground sm:text-5xl">
        Best of the <span className="italic">San Diego coast</span>
      </h2>
      <p className="font-body mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground">
        Curated starting points for the most searched San Diego coast topics — live
        tide charts, dog-friendly beaches, snorkeling, surf, and every sandy spot
        from Imperial Beach to Oceanside.
      </p>

      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {teasers.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            className="group flex items-start gap-4 rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary/40 hover:shadow-lg hover:shadow-primary/5 hover:-translate-y-0.5"
          >
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-secondary text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
              <t.icon className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <h3 className="font-display text-lg font-semibold text-foreground flex items-center gap-2">
                {t.label}
                <ArrowRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-1 group-hover:text-primary" />
              </h3>
              <p className="font-body mt-1.5 text-sm leading-relaxed text-muted-foreground">
                {t.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default TeaserGrid;
